@if (isLoading()) {
  <div class="profile-avatar-skeleton">
    <ngx-skeleton-loader count="1" [theme]="{ width: '100%', height: '100%' }" />
  </div>
} @else {
  <ol-avatar
    [src]="avatarUrl()"
    [alt]="profile()?.username || 'Profile avatar'"
    size="custom"
    borderRadius="8px"
    class="profile-avatar"
  />
}
